<template>
  <div>
    <v-card-title class="justify-center text-h5">
      {{ tableName }}
    </v-card-title>
    <v-flex class="d-flex mb-8 justify-space-between">
      <!-- <div class="col-5">
        <v-text-field
          outlined
          dense
          v-model="companies.search"
          append-icon="mdi-magnify"
          :label="$t('searchLabel')"
          single-line
          hide-details
        ></v-text-field>
      </div> -->
      <v-spacer></v-spacer>
      <div>
        <v-btn
          v-if="showSyncButton"
          class="white--text"
          color="primary my-2 ml-2"
          :loading="syncLoading"
          @click="syncCompanies()"
        >
          <v-icon left class="mr-4"> mdi-sync </v-icon> {{ $t("syncLabel") }}
        </v-btn>
      </div>
    </v-flex>
    <v-data-table
      :options.sync="options"
      :footer-props="companies.footerProps"
      :server-items-length="1"
      :headers="companies.headers"
      :items="companies.values"
      :loading="loading"
      :loading-text="$t('tableLoadingLabel')"
    >
      <template v-if="canModify" #item.actions="{ item }">
        <v-btn
          class="ml-4 primary--text"
          small
          outlined
          :to="{ name: 'SalesPartnerCompany' , params: { companyId: item.id } } ">
          {{ $t("manageLabel") }}</v-btn>
      </template>
      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>
    <v-pagination v-model="page" :length="pageCount" @input="getFirstTierCompanies()"></v-pagination>
<!--    <v-dialog-->
<!--        :close-delay="3000"-->
<!--        v-model="snackbar.show"-->
<!--        max-width="360"-->
<!--        overlay-opacity="0.3"-->
<!--    >-->
<!--      <v-card>-->
<!--        <div class="pa-4 pb-0">-->
<!--          <div class="subtitle-1 text-center" v-text="snackbar.message"></div>-->
<!--        </div>-->
<!--        <v-card-actions>-->
<!--          <v-btn-->
<!--              small-->
<!--              class="mx-auto"-->
<!--              color="primary"-->
<!--              @click="snackbar.show = false"-->
<!--          >-->
<!--            {{$t('closeLabel')}}-->
<!--          </v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
  </div>
</template>
<script>
export default {
  name: "CompaniesTable",
  data() {
    return {
      options: {},
      page: 1,
      pageCount: 1,
      amount: 10,
      sortBy:'',
      sortDesc: null,
      syncLoading: false,
      openPopup: false,
      loading: true,
      newCompany: {
        companyName: "",
        countryCode: "",
        postalCode: "",
        city: "",
        address: "",
        users: [],
        dateCreated: "",
        parent: null,
      },
      snackbar: {
        show: false,
        message: "",
      },
      companies: {
        search: "",
        headers: [
          {
            text: this.$t('salesCompanyNumberLabel'),
            value: "companyNumber",
          },
          {
            text: this.$t('salesNameLabel'),
            value: "name1",
          },
          {
            text: this.$t('salesCountryCodeLabel'),
            value: "countryCode",
          },
          {
            text: this.$t('salesCityLabel'),
            value: "city",
          },
          {
            text: "",
            sortable: false,
            value: "actions",
            align: "end",
          },
        ],
        values: [],
        footerProps:{
          'items-per-page-options' : [5, 10, 15, 20, -1],
          'disable-pagination': true,
          'next-icon': null,
          'prev-icon': null,
          'page-text' : '',
          'items-per-page-all-text': this.$t('allLabel'),
          'items-per-page-text': this.$t('rowsPerPageLabel')
        }
      },
    };
  },
  props: {
    tableName: String,
    parentCompanyId: Number,
    canModify: Boolean,
    canAddNew: Boolean,
    showSyncButton: Boolean,
  },
  watch: {
      options: {
        handler(){
          const options = this.options;
          this.amount = options.itemsPerPage
          const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
          const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
          this.sortBy = sortBy;
          this.sortDesc = sortDesc;
          if (this.$props.parentCompanyId !== 0) {
            this.getCompaniesByParent();
          } else {
            this.getFirstTierCompanies();
          }
        },
        deep: true
      }
    },
  methods: {
    syncCompanies() {
      this.syncLoading = true;
      this.axios
        .get("/api/sap/synccompanyandusers")
        .then((response) => {
          this.companies.values = response.data;
          this.loading = false;
          this.syncLoading = false;
        })
        .catch((error) => {
          console.error(error.response);
          this.snackbar.message = this.$t('syncError');
          this.snackbar.show = true;
          this.$EventBus.$emit("snackbar", this.snackbar);
          this.loading = false;
          this.syncLoading = false;
        });
    },
    getFirstTierCompanies() {
      this.axios
        .get("/api/company/getfirsttiercompanies", {
          params: { 
            amount: this.amount, 
            page: this.page, 
            sortBy: this.sortBy, 
            sortDesc: this.sortDesc 
          }
        })
        .then((response) => {
          this.companies.values = response.data.companies;
          this.pageCount = response.data.pages;
          this.loading = false;
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    getCompaniesByParent() {
      this.axios
        .get("/api/company/getByParent", {
          params: {
            id: this.$props.parentCompanyId,
            amount: this.amount,
            page: this.page, 
            sortBy: this.sortBy, 
            sortDesc: this.sortDesc
          },
        })
        .then((response) => {
          this.companies.values = response.data;
          this.pageCount = response.data.pages;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    addUser() {
      const userObject = {
        firstName: "",
        lastName: "",
        email: "",
        userType: 6,
      };
      this.newCompany.users.push(userObject);
    },
    removeUser(index) {
      this.newCompany.users.splice(index, 1);
    },
  },
  mounted() {
    if (this.$props.parentCompanyId !== 0) {
      this.getCompaniesByParent();
    } else {
      this.getFirstTierCompanies();
    }
  },
};
</script>
<style scoped>
</style>